import React from 'react';
import { useTranslation } from 'react-i18next';
import useShow from '../../hooks/useShow';
import staticSource from '../../library/staticSource';

const WaitingPage = () => {
  const { t } = useTranslation();
  const { episodeInfo, showInfo } = useShow();
  const isMunchen = showInfo?.company_name === 'DOK.fest München';

  const headingText = isMunchen ? (
    <>
      <span style={{ fontSize: '0.8em' }}>Nach der Vorführung kann abgestimmt werden.</span>
      <br />
      <br />
      <span style={{ fontSize: '0.8em' }}>
        Voting is available after the screening.
      </span>
    </>
  ) : (
    t('pages.waiting.come_back')
  );

  return (
    <div className="page welcome">
      {episodeInfo && episodeInfo.image && (
        <div
          className="welcome-background"
          style={{
            backgroundImage: `url(${staticSource(episodeInfo.image)})`,
          }}
        />
      )}
      <div className="page-inner">
        <div className="page__title">
          <h1 style={{ textTransform: 'none' }}>{headingText}</h1>
        </div>
      </div>
    </div>
  );
};

export default WaitingPage;
